<template>
    <div class="daytimeset">
      <el-row class="daytimesettitle">
        <el-col>天数时刻设置</el-col>
      </el-row>
      <el-row class="daytimesettohospital">
        <el-col :span=12>
          <el-row class="textalign">设置入院当天是否计费</el-row>
          <el-row class="width75">
            <span>时</span>
            <span>
              <el-time-picker v-model="value1">
              </el-time-picker>
            </span>
            <span>分</span>
            <span>
              <el-time-picker arrow-control v-model="value2">
              </el-time-picker>
            </span>
          </el-row>
        </el-col>
        <el-col :span=12>
          <el-row class="textalign">设置出院当天是否计费</el-row>
          <el-row class="width75">
            <span>时</span>
            <span>
              <el-time-picker v-model="value3">
              </el-time-picker>
            </span>
            <span>分</span>
            <span>
              <el-time-picker arrow-control v-model="value4">
              </el-time-picker>
            </span>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="textalign">设置出院当天是否计费</el-row>
      <el-row class="width40">
        <span>时</span>
        <span>
          <el-time-picker v-model="value3">
          </el-time-picker>
        </span>
        <span>分</span>
        <span>
          <el-time-picker arrow-control v-model="value4">
          </el-time-picker>
        </span>
      </el-row>
      <el-row class="button">
        <el-button type="primary" @click.native="submit">保存</el-button>
      </el-row>
    </div>
</template>
<script>
export default {
  name:"DayTimeSet",
  components:{},
  data(){
    return {
      value1: null,
      value2: null,
      value3: null,
      value4: null,
      value5: null,
      value6: null,
      ruleId: null,
    }
  },
  methods:{
    submit(){
      let checkInTime = this.formatTime(this.value1, this.value2);
      let checkOutTime = this.formatTime(this.value3, this.value4);
      let params = {
        homeId: Number(sessionStorage.getItem("groupId")),
        checkInBillingTime: checkInTime,
        checkOutBillingTime: checkOutTime
      };
      if (this.ruleId) params.id = this.ruleId;
      this.$postJson("fmc/billingRule/save", params).then(res => {
        if (res.code == 200) {
          this.$message({ message: "保存成功", type: "success" });
          this.queryConfig();
        } else {
          this.$message({ message: res.message || "保存失败", type: "error" });
        }
      });
    },
    formatTime(hourDate, minuteDate){
      if (!hourDate || !minuteDate) return "";
      let h = hourDate.getHours();
      let m = minuteDate.getMinutes();
      return String(h).padStart(2, '0') + ":" + String(m).padStart(2, '0');
    },
    parseTime(timeStr){
      if (!timeStr) return [null, null];
      let parts = timeStr.split(":");
      let hDate = new Date(2016, 0, 1, parseInt(parts[0] || 0), 0);
      let mDate = new Date(2016, 0, 1, 0, parseInt(parts[1] || 0));
      return [hDate, mDate];
    },
    queryConfig(){
      let params = { homeId: Number(sessionStorage.getItem("groupId")) };
      this.$postJson("fmc/billingRule/getByHomeId", params).then(res => {
        if (res.code == 200 && res.result) {
          this.ruleId = res.result.id;
          let checkIn = this.parseTime(res.result.checkInBillingTime);
          this.value1 = checkIn[0];
          this.value2 = checkIn[1];
          let checkOut = this.parseTime(res.result.checkOutBillingTime);
          this.value3 = checkOut[0];
          this.value4 = checkOut[1];
        }
      });
    }
  },
  created(){
    this.queryConfig();
  },
  mounted(){
    
  }
}
</script>
<style lang="scss" scoped>
  .daytimeset{
    .daytimesettitle{
      height:50px;
      line-height:50px;
      font-size:18px;
      font-weight:700;
    }
    .textalign{
      text-align:center;
      margin:50px;
    }
    .width75{
      width:75%;
      margin:0 auto;
    }
    .width40{
      width:40%;
      margin:0 auto;
    }
    .button{
      height:100px;
      line-height: 100px;
      margin: 100px;
      text-align:center;
    }
  }
</style>